// extracted by mini-css-extract-plugin
export default {"objectional-product-modal":"objectional-product-modal","modal-heading":"modal-heading","modal-body":"modal-body","multi-per-issue-modal":"multi-per-issue-modal"};